import React, { useContext } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import NewsEditComponent from "../../components/News/NewsEditComponent";


const AdminActualiteAdd = () => {

  const { t } = useTranslation();


  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)

  useEffect(() => {
    setpageNavLink({ path: "/dashboard/admin", label:"adminDashboard" })
    setpageTitle("addNews")
    setalertTitle("")
    setnavLinks([{ path: "/dashboard/admin/adminactualitelist", label: "navigation8.1" }])
  }, [])



  return (
    <NewsEditComponent />
  );
};

export default AdminActualiteAdd;
